import { render, staticRenderFns } from "./shareManage.vue?vue&type=template&id=9336810e&scoped=true&"
import script from "./shareManage.vue?vue&type=script&lang=js&"
export * from "./shareManage.vue?vue&type=script&lang=js&"
import style0 from "./shareManage.vue?vue&type=style&index=0&id=9336810e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9336810e",
  null
  
)

export default component.exports